var map = {
	"./img-section2-1.svg": "A8/M",
	"./img-section2-10.svg": "e8NF",
	"./img-section2-11.svg": "LJb7",
	"./img-section2-12.svg": "dLOX",
	"./img-section2-13.svg": "wxJH",
	"./img-section2-14.svg": "euVu",
	"./img-section2-15.svg": "bgpi",
	"./img-section2-16.svg": "Zjhe",
	"./img-section2-17.svg": "bhhE",
	"./img-section2-18.svg": "WhS6",
	"./img-section2-2.svg": "iInf",
	"./img-section2-3.svg": "yBVI",
	"./img-section2-4.svg": "DNrG",
	"./img-section2-5.svg": "0+tX",
	"./img-section2-6.svg": "7miW",
	"./img-section2-7.svg": "kTsS",
	"./img-section2-8.svg": "uAwK",
	"./img-section2-9.svg": "9cWP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Q460";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/img\-section2\-.*\.svg$
// module id = Q460
// module chunks = 1